module.exports = __webpack_public_path__ + "img/软件产品-pow6.040ec13c.png";